import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MainService } from 'src/app/services/main.service';


import 'bootstrap';
import { Console, log } from 'console';

@Component({
    selector: 'app-client-report',
    templateUrl: './client-report.component.html',
    styleUrls: ['./client-report.component.scss']
})

export class ClientReportComponent implements OnInit {
    language = JSON.parse(localStorage.getItem('language'));
    language_flag = localStorage.getItem('language_flag');


    @Input()
    disableHeader = false

    private personalID: string;
    private inputOTP: string;
    pidReq = false;
    otpReq = false;
    showLogin = true;
    requestOTP = false;
    showPDPA = false;
    refOTP: string;
    otpMsg: string;
    otpError = this.language.cs_otp;
    loginError = this.language.cs_pid;
    uid: string;
    consentDesc = [];
    consentData = new Map<string, boolean>();

    loginSeccess = false;
    customer_id: any;
    customer_Name: string;
    customer_title_name: string;
    customer_Name_En: string;
    customer_title_name_En: string;
    toDay: string;


    fundList: Array<any> = [];
    fundListfilter: Array<any> = [];
    HolderNo: Array<any> = [];
    typeFundList: String[]= ['LTF', 'RMF', 'SSF', 'SSFX','TESG'];
    select_fund = [];
    selectFundList: Array<any> = [];
    funListGroup: Array<any> = [];
    AgentID: any;


    checkmonth: Array<Object> = [
        {
            number: 1,
            name: 'มกราคม',
            nameEn: 'January'
        },
        {
            number: 2,
            name: 'กุมภาพันธ์',
            nameEn: 'February'
        },
        {
            number: 3,
            name: 'มีนาคม',
            nameEn: 'March'
        },
        {
            number: 4,
            name: 'เมษายน',
            nameEn: 'April'
        },
        {
            number: 5,
            name: 'พฤษภาคม',
            nameEn: 'May'
        },
        {
            number: 6,
            name: 'มิถุนายน',
            nameEn: 'June'
        },
        {
            number: 7,
            name: 'กรกฎาคม',
            nameEn: 'July'
        },
        {
            number: 8,
            name: 'สิงหาคม',
            nameEn: 'August'
        },
        {
            number: 9,
            name: 'กันยายน',
            nameEn: 'September'
        },
        {
            number: 10,
            name: 'ตุลาคม',
            nameEn: 'October'
        },
        {
            number: 11,
            name: 'พฤศจิกายน',
            nameEn: 'November'
        },
        {
            number: 12,
            name: 'ธันวาคม',
            nameEn: 'December'
        }
    ];
    monthListEN = [];
    monthListTH: Array<any> = [];
    year101: Array<any> = [];
    HolderNostr: string;
    isOne = false;
    timeLogout = 0;
    TimeLogoutDate = 20; //Minutes
    timearry: Array<any> = [];
    customerNameArry: Array<any> = [];
    RouterLog: string;
    PidNo: string;
    isVerifyPIDNo: boolean;






    constructor(private route: ActivatedRoute, private router: Router, private mainService: MainService,
        private loader: NgxUiLoaderService) { }

    ngOnInit() {
        this.loadMyStorage(
            sessionStorage.getItem("PIDNo"),
            sessionStorage.getItem("id"),
            sessionStorage.getItem("AgentID"),
            JSON.parse(sessionStorage.getItem("TimeLogout")),
            JSON.parse(sessionStorage.getItem("CType")),
            parseInt(sessionStorage.getItem("cusid")));
        this.BackOneYear();
        this.getDataCustomer(sessionStorage.getItem('PIDNo'));
        this.backFiveYear();
        // $('#warningModalForClient').modal('show')
        this.timearry = JSON.parse(sessionStorage.getItem("TimeLogout"));
        if (sessionStorage.getItem("LoginSuccess") !== null || sessionStorage.getItem("LoginSuccess") === 'Y') {
            this.checkSevice();
        }

    }

    checkSevice() {
        this.route.params.subscribe(param => {
            if (this.AgentID == '1') {
                if (param['id'] === 'DSRR') {
                    this.openDSAR();
                    this.router.navigate(['/client-report/', 'ED']);
                }
                else if (param['id'] === 'RCC') {
                    this.openConsent();
                    this.router.navigate(['/client-report/', 'ED']);
                }
                else if (param['id'] === 'AITE') {
                    this.openTaxConsent();
                }
                else if (param['id'] === 'AP') {
                    this.openAssetProfile();
                }
                this.RouterLog = param['id'];
            }
            else {
                if (param['id'] === 'AITE') {
                    this.openTaxConsent();
                }
                else {
                    this.router.navigate(['/client-report/', 'ED']);
                }
                this.RouterLog = param['id'];
            }
        })
    }

    TimeCountLogOut() {
        this.timeLogout = this.timeLogout + 1;
        if (this.timeLogout === 900 && sessionStorage.getItem("LoginSuccess") === 'Y') {
            this.clickLogout();
        } else {
            setTimeout(() => { this.TimeCountLogOut() }, 1000);
        }
    }

    checkAgentID() {
        this.AgentID = sessionStorage.getItem('AgentID');
        if (this.AgentID == 1) {
            this.isOne = true;
        } else {
            this.isOne = false;
        }
    }

    goDownloadPage() {
        this.router.navigate(['/download-form']);
    }

    checkLogin() {
        if (this.personalID === '' || this.personalID === undefined) {
            this.pidReq = true;
            this.showPDPA = false;
            this.requestOTP = false;
            this.loginError = this.language.cs_pid;
        } else {
            this.loader.start();
            this.pidReq = false;
            this.otpReq = false;
            // check pid and send otp
            this.mainService.GetDataRequest(this.personalID).subscribe(params => {
                console.log(params)
                if (params['ErrorCode'] == '401') {
                    this.loginError = this.language.ed_loging_error_401;
                    this.loginError = this.language.ed_loging_error_401;
                    this.pidReq = true;
                    this.otpReq = true;
                    this.loader.stop();
                }
                else if (params['ErrorCode'] == '404') {
                    this.loginError = this.language.ed_login_error_404;
                    this.loginError = this.language.ed_login_error_404;
                    this.pidReq = true;
                    this.otpReq = true;
                    this.loader.stop();
                }
                else {
                    this.route.params.subscribe(param => {
                        this.RouterLog = (param['id'] == 'AITE') ? param['id'] : "";
                    })
                    sessionStorage.setItem('CType', params['VerifyPIDNo']);
                    sessionStorage.setItem('cusid', params['Result'][0]['CustomerId']);
                    this.mainService.checkCustomerPID(this.personalID, 'mobileOTP', 'W').subscribe(response => {
                        if (response['Success'] === true) {
                            if (params['VerifyPIDNo'] == false && this.RouterLog == 'AITE') {
                                $('#warningModalForClientReport').modal('show')
                            }
                            this.refOTP = response['Result'];
                            this.otpMsg = response['Message'];
                            this.otpError = '';
                            this.showLogin = false;
                            this.showPDPA = false;
                            // if found pid then send otp
                            this.requestOTP = true;
                            this.AgentID = response['Agent'];
                            if (params['VerifyPIDNo'] == false && this.RouterLog == 'AITE') {
                                this.router.navigate(['/client-report/', 'ED']);
                            }
                        } else {
                            this.pidReq = true;
                            this.otpReq = true;
                            if (response['Message'] == '405') {
                                this.loginError = this.language.ed_login_error_405;
                                this.otpError = this.language.ed_login_error_405;
                            } else if (response['Message'] == '404') {
                                this.loginError = this.language.ed_login_error_404;
                                this.otpError = this.language.ed_login_error_404;
                            } else if (response['Message'] == '403') {
                                this.loginError = this.language.ed_login_error_403;
                                this.otpError = this.language.ed_login_error_403;
                            } else if (response['Message'] == '402') {
                                this.loginError = this.language.ed_login_error_402;
                                this.otpError = this.language.ed_login_error_402;
                            }
                            // this.loginError = response['Message'];
                            // this.otpError = response['Message'];
                        }
                    });
                    this.loader.stop();
                    this.isVerifyPIDNo = params['VerifyPIDNo'];
                }
            });
        }
    }

    checkOTP() {
        if (this.inputOTP === '' || this.inputOTP === undefined) {
            this.otpReq = true;
            this.showPDPA = false;
            this.otpError = this.language.cs_otp;
        } else {
            this.loader.start();
            // check OTP
            this.otpReq = false;
            this.otpError = this.language.cs_otp;
            // if correct otp then
            this.mainService.checkCustomerOTP(this.personalID, 'mobileOTP', 'W', this.refOTP, this.inputOTP).subscribe(response => {
                if (response['Success'] === true) {
                    this.uid = response['Message'];
                    this.showPDPA = true;
                    this.requestOTP = false;
                    this.loginSeccess = true;
                    sessionStorage.setItem('LoginSuccess', 'Y');
                    this.Login(this.personalID, this.uid, this.AgentID);
                    this.checkSevice();
                } else {
                    if (response['Message'] == '101') {
                        this.otpError = this.language.ed_otp_error_103;
                    } else if (response['Message'] == '102') {
                        this.otpError = this.language.ed_otp_error_102;
                    }
                    this.otpReq = true;
                    this.requestOTP = true;
                }
            });
            this.loader.stop();
        }
    }

    getOTPTitle() {
        return this.language.cs_otp_title + '(Ref : ' + this.refOTP + ') ' + this.otpMsg + this.language.cs_otp_title2;
    }

    openDSAR() {
        // window.open('https://privacyportal-apac.onetrust.com/webform/fbb17504-0994-4d1e-9ede-8617a50a50eb/draft/f5fa2705-9819-49b9-a52d-44a770554214');
        window.open('https://privacyportal-apac.onetrust.com/webform/fbb17504-0994-4d1e-9ede-8617a50a50eb/04521887-a33d-46e1-a5f1-de880a450ab9');
    }

    openConsent() {
        this.loader.start();
        const cusid = sessionStorage.getItem('id');
        this.mainService.loadConsent(cusid, sessionStorage.getItem('PIDNo')).subscribe(response => {
            this.consentDesc = response['Purposes'];
            $('#ucModal').modal({ backdrop: 'static', keyboard: false });
            this.loader.stop();
        });
    }

    closeCovidModal() {
        const data: ConsentViewModel[] = [];
        this.consentDesc.forEach(e => {
            if (e['TransactionType'] === 'ACTIVE') {
                e['TransactionType'] = null;
            }
            const consentObj = { Id: e['Id'], TransactionType: e['TransactionType'] };
            data.push(consentObj);
        });
        this.loader.start();
        this.mainService.sendConsent(sessionStorage.getItem('PIDNo'), data).subscribe(response => {
            this.loader.stop();
            $('#ucModal').modal('hide');
        });
    }

    onChangeConsent(item) {
        if (item.TransactionType === 'ACTIVE') {
            item.TransactionType = 'WITHDRAWN'
        } else {
            item.TransactionType = 'ACTIVE'
        }
    }


    Login(pid, id, agentID) {
        const login = document.getElementById('click-Login');
        const sectionlogin = document.getElementById('client-report-Login-On');
        if (sectionlogin.style.display === 'none') {
            sectionlogin.style.display = 'block';
            login.style.display = 'none';
        }
        this.getDataCustomer(pid);
        this.saveMyStorage(pid, id, agentID);
        this.timeLogout = 0;
        this.TimeCountLogOut();
        this.checkAgentID();
    }

    clickLogout() {
        this.loader.start();
        if (this.router.url === '/client-report/ED') {
            const sectionlogin = document.getElementById('client-report-Login-On');
            const login = document.getElementById('click-Login');
            if (sectionlogin != null && login != null) {
                if (login.style.display === 'none') {
                    login.style.display = 'block';
                    sectionlogin.style.display = 'none';
                }
            }
            this.ResetCard();
        }
        else{
            this.timeLogout = 0;
        }
        this.clearMystorageLogin();
        location.reload();
        this.loader.stop();
    }
    getDataCustomer(pid) {
        this.loader.start();
        if (pid === null) {
            this.loader.stop();
        } else {
            this.mainService.GetDataRequest(pid).subscribe(params => {
                if (params['Result'] == null) {
                    alert("กรุณาติดต่อหน่วยงานลูกค้าสัมพันธ์ โทร. 02-659-8888 กด 1")
                }
                else {
                    this.customer_id = params['Result'][0]['CustomerId'];
                    sessionStorage.setItem('cusid', this.customer_id);
                    // if(this.language_flag == 'th'){
                    //     this.customer_Name = params['Result'][0]['CustomerName'];

                    // }
                    this.customerNameArry = params['Result'][0]['CustomerName'].split(',');
                    this.customer_Name = this.customerNameArry[1];
                    this.customer_Name_En = this.customerNameArry[3];
                    this.customer_title_name_En = this.customerNameArry[2];
                    if (this.customerNameArry[0] === 'นาย' || this.customerNameArry[0] === 'นาง' || this.customerNameArry[0] === 'นางสาว') {
                        this.customer_title_name = 'คุณ';
                    } else {
                        this.customer_title_name = this.customerNameArry[0];
                    }
                    this.fundList = params['Result'][0]['FundList'];
                    this.fundList = this.fundList.sort((a, b) => (a.FundCode > b.FundCode) ? 1 : -1);
                    this.HolderNostr = params['Result'][0]['HolderNo'];
                    this.HolderNo = this.HolderNostr.split(',');
                    this.HolderNo = this.HolderNo.sort((a, b) => (a > b ? -1 : 1));
                    this.HolderNo.forEach((element, index) => {
                        if (element === '') {
                            this.HolderNo.splice(index, 1);
                        }
                    })
                }
                this.loader.stop();
            });
        }
    }
    BackOneYear() {
        let get_months: number = (new Date().getMonth());
        while (this.monthListTH.length < 12) {
            if (this.language_flag !== 'th') {
                this.monthListTH.push(this.checkmonth[get_months]['nameEn']);
            }
            else {
                this.monthListTH.push(this.checkmonth[get_months]['name']);
            }
            get_months = get_months + 1;
            if (get_months == 12) {
                get_months = 0;
            }
        }
    }

    backFiveYear() {
        const get_Year: number = (new Date().getFullYear())
        const startDateCount = new Date(get_Year,0,16);
        let countDate = 1;
        if (new Date() < startDateCount) {
            countDate = countDate + 1;
        }
        if (this.language_flag !== 'th') {
            for (countDate; countDate <= 5; countDate++) {
                this.year101.push((get_Year - countDate));
            }
        }
        else {
            for (countDate; countDate <= 5; countDate++) {
                this.year101.push((get_Year - countDate) + 543);
            }
        }
    }
    saveMyStorage(pid, id, agentID) {
        let time = new Date();
        let time2 = new Date(time);
        sessionStorage.setItem('PIDNo', pid);
        sessionStorage.setItem('id', id);
        sessionStorage.setItem('AgentID', agentID);
        time2.setMinutes(time.getMinutes() + this.TimeLogoutDate);
        sessionStorage.setItem('TimeLogout', JSON.stringify([time2.getHours(), time2.getMinutes(), time2.getDay()]));
    }

    checkTimeOut(timeout) {
        let time = new Date();
        let time2 = new Date(time);
        if (time.getHours() > timeout[0] && time.getMinutes() <= timeout[1]) {
            return true;
        }
        else if (time.getHours() >= timeout[0] && time.getMinutes() >= timeout[1]) {
            return true;
        }
        else if (time.getDay() != timeout[2] || time.getDay() !== timeout[2]) {
            return true
        }
        else {
            return false;
        }

    }

    loadMyStorage(pid, id, agentID, timeout, verifyPid, cusid) {
        if (pid !== null || id !== null || agentID !== null) {
            if (this.checkTimeOut(timeout) == true) {
                this.clickLogout();
            }
            else {
                this.customer_id = cusid;
                this.PidNo = pid;
                this.isVerifyPIDNo = verifyPid;
                this.Login(pid, id, agentID);
                this.checkAgentID();
            }
        }

    }
    clearMystorageLogin() {
        sessionStorage.removeItem('PIDNo');
        sessionStorage.removeItem('id');
        sessionStorage.removeItem('AgentID');
        sessionStorage.removeItem('LoginSuccess');
        sessionStorage.removeItem('TimeLogout');
        sessionStorage.removeItem('CType');
        sessionStorage.removeItem('cusid');
    }

    dowloadReport(temcod, holderno, date, fundlists) {
        this.loader.start();
        this.timeLogout = 0;
        this.mainService.downloadFilePdf(temcod, holderno, date, fundlists).subscribe(response => {
            if (response === "Not Found") {
                alert("ไม่พบไฟล์รายงาน");
            }
            else {
                const linkSource = 'data:application/pdf;base64,' + response;
                const downloadLink = document.createElement('a');
                this.nameFilePdf();
                const fileName = temcod + this.customer_id + this.toDay;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
            this.loader.stop();
        })
    }
    dowlondHolderReport() {
        this.loader.start();
        let inputMonth = document.getElementById("selectMonth") as HTMLInputElement | null;
        let inputHolderNo = document.getElementById("selectHolderNo") as HTMLInputElement | null;
        let dateMonth = "0";
        for (let i = 0; i <= 11; i++) {
            if (this.checkmonth[i]['name'] === inputMonth.value || this.checkmonth[i]['nameEn'] === inputMonth.value) {
                dateMonth = String(this.checkmonth[i]['number']);
            }
        }
        if (inputHolderNo.value === 'HolderAll') {
            this.dowloadReport('RPT107', this.HolderNostr, dateMonth, this.fundList);
        } else {
            this.dowloadReport('RPT107', inputHolderNo.value, dateMonth, this.fundList);
        }
    }

    downloadReportConfimation() {
        this.selectFundList = [];
        const inputFundList = document.getElementById('selectfundListRPT106') as HTMLInputElement | null;
        const inputHolderNo = document.getElementById('selectHolderNoRPT106') as HTMLInputElement | null;
        this.loader.start();
        let fundListlLngth = this.fundList.length;
        for (let i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT106', this.HolderNostr, '0', this.fundList);
        } else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
            this.dowloadReport('RPT106', this.HolderNostr, '0', this.selectFundList);
        } else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT106', inputHolderNo.value, '0', this.fundList);
        } else {
            this.dowloadReport('RPT106', inputHolderNo.value, '0', this.selectFundList);
        }

    }

    downloadReportPurchase() {
        this.loader.start();
        this.selectFundList = [];
        const inputFundList = document.getElementById('selectfundListRPT101') as HTMLInputElement | null;
        const inputHolderNo = document.getElementById('selectHolderNoRPT101') as HTMLInputElement | null;
        const inputDateYear = document.getElementById('selectDateYearRPT101') as HTMLInputElement | null;
        const fundListlLngth = this.fundList.length;
        let yearTH = parseInt(inputDateYear.value) - 543
        for (let i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (this.language_flag === 'th') {
            if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, yearTH.toString(), this.fundListfilter);
            } else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, yearTH.toString(), this.selectFundList);
            } else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', inputHolderNo.value, yearTH.toString(), this.fundListfilter);
            } else {
                this.dowloadReport('RPT101', inputHolderNo.value, yearTH.toString(), this.selectFundList);
            }
        }
        else {
            if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, inputDateYear.value, this.fundListfilter);
            } else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
                this.dowloadReport('RPT101', this.HolderNostr, inputDateYear.value, this.selectFundList);
            } else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
                this.dowloadReport('RPT101', inputHolderNo.value, inputDateYear.value, this.fundListfilter);
            } else {
                this.dowloadReport('RPT101', inputHolderNo.value, inputDateYear.value, this.selectFundList);
            }
        }
    }

    downloadReportRedemption() {
        this.loader.start();
        this.selectFundList = [];
        const inputFundList = document.getElementById('selectfundListRPT102') as HTMLInputElement | null;
        const inputHolderNo = document.getElementById('selectHolderNoRPT102') as HTMLInputElement | null;
        const fundListlLngth = this.fundList.length;
        for (let i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT102', this.HolderNostr, '0', this.fundListfilter);
        } else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
            this.dowloadReport('RPT102', this.HolderNostr, '0', this.selectFundList);
        } else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT102', inputHolderNo.value, '0', this.fundListfilter);
        } else {
            this.dowloadReport('RPT102', inputHolderNo.value, '0', this.selectFundList);
        }
    }

    downloadReportTransfer() {
        this.loader.start();
        this.selectFundList = [];
        const inputFundList = document.getElementById('selectfundListRPT103') as HTMLInputElement | null;
        const inputHolderNo = document.getElementById('selectHolderNoRPT103') as HTMLInputElement | null;

        const fundListlLngth = this.fundList.length;
        for (let i = 0; i < fundListlLngth; i++) {
            if (inputFundList.value === this.fundList[i]['FundCode']) {
                this.selectFundList.push(this.fundList[i]);
            }
        }
        if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT103', this.HolderNostr, '0', this.fundListfilter);
        } else if (inputHolderNo.value === 'HolderNoAll' && inputFundList.value !== 'fundListAll') {
            this.dowloadReport('RPT103', this.HolderNostr, '0', this.selectFundList);
        } else if (inputHolderNo.value !== 'HolderNoAll' && inputFundList.value === 'fundListAll') {
            this.dowloadReport('RPT103', inputHolderNo.value, '0', this.fundListfilter);
        } else {
            this.dowloadReport('RPT103', inputHolderNo.value, '0', this.selectFundList);
        }
    }
    nameFilePdf() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var hh = String(today.getHours()).padStart(2, '0');
        var mimi = String(today.getMinutes()).padStart(2, '0');
        var ssss = String(today.getSeconds()).padStart(2, '0');
        this.toDay = dd + mm + yyyy + hh + mimi + ssss;
    }

    // =================================CheckBox============================================================//

    checkBoxSelectall = [
        {
            Name: 'Select ALL',
            isChecked: false
        }
    ]

    checkBoxList = [
        {
            Name: 'LTF',
            isChecked: false
        },
        {
            Name: 'RMF',
            isChecked: false
        },
        {
            Name: 'SSF',
            isChecked: false
        },
        {
            Name: 'SSFX',
            isChecked: false
        },
        {
            Name: 'ThaiESG',
            isChecked: false
        }
    ];
    selectCount = 0;

    selectAllTest(elemholder, elemfund, but) {
        this.timeLogout = 0;
        const selecthol = document.getElementById(elemholder) as HTMLInputElement | null;
        const selectfund = document.getElementById(elemfund) as HTMLInputElement | null;
        const butt = document.getElementById(but) as HTMLInputElement | null;
        const Year101 = document.getElementById('selectDateYearRPT101') as HTMLInputElement | null;
        const fundLength = this.fundList.length;
        this.fundListfilter = [];
        let myArry = [];
        const checkboxlength = this.checkBoxList.length;
        const selectAll = this.checkBoxSelectall[0]['isChecked'];
        if (selectAll === true) {
            for (let i = 0; i < checkboxlength; i++) {
                this.checkBoxList[i]['isChecked'] = true;
            }
            this.select_fund = this.typeFundList;
            this.selectCount = this.typeFundList.length;;
            if (this.select_fund[this.select_fund.length - 1] === 'SSFX') {
                for (let l = 0; l < fundLength; l++) {
                    const mySSFX = this.fundList[l]['FundCode'];
                    myArry = mySSFX.split('-');
                    if (myArry[myArry.length - 1] === this.select_fund[this.select_fund.length - 1] || this.fundList[l]['FundTypeGroup'] !== null) {
                        if (myArry[myArry.length - 1] === this.select_fund[this.select_fund.length - 1]) {
                            this.fundList[l]['FundTypeGroup'] = 'SSFX';
                        }
                        this.fundListfilter.push(this.fundList[l]);
                    }
                }
            } else {
                for (let l = 0; l < fundLength; l++) {
                    const mySSFX = this.fundList[l]['FundCode'];
                    myArry = mySSFX.split('-');
                    if (this.fundList[l]['FundTypeGroup'] !== null && myArry[myArry.length - 1] !== 'SSFX') {
                        this.fundListfilter.push(this.fundList[l]);
                    }
                }
            }
            this.fundListfilter = this.fundListfilter.sort((a, b) => (a.FundCode > b.FundCode) ? 1 : -1);
            selecthol.disabled = false;
            selectfund.disabled = false;
            butt.disabled = false;
            Year101.disabled = false;
        } else if (selectAll === false) {
            for (let i = 0; i < checkboxlength; i++) {
                this.checkBoxList[i]['isChecked'] = false;
            }
            this.selectCount = 0;
            this.select_fund = [];
            selecthol.disabled = true;
            selectfund.disabled = true;
            butt.disabled = true;
            Year101.disabled = true;
        }
    }


    ResetCard() {
        this.select_fund = [];
        this.fundListfilter = [];
        this.timeLogout = 0;

        const checkboxlength = this.checkBoxList.length;
        this.checkBoxSelectall[0]['isChecked'] = false;
        for (let i = 0; i < checkboxlength; i++) {
            this.checkBoxList[i]['isChecked'] = false;
        }
        this.clearRPT101();
        this.clearRPT102();
        this.clearRPT103();
        this.clearRPT106();
        this.clearRPT107();
        this.selectCount = 0;
    }

    selectTest(elemholder, elemfund, but) {
        const checkboxlength = this.checkBoxList.length;
        this.timeLogout = 0;
        for (let i = 0; i < checkboxlength; i++) {
            let val = this.checkBoxList[i]['Name'];
            val = (val === 'ThaiESG')? 'TESG':val;
            const valcheck = this.checkBoxList[i]['isChecked'];
            const found = this.select_fund.find(element => element === val);
            const foundIndex = this.select_fund.indexOf(val);
            if (valcheck === true && found === undefined) {
                this.select_fund.push(val);
                this.AddFundListTest(val, elemholder, elemfund, but);
                this.selectCount += 1;
            } else if (valcheck === false && found !== undefined) {
                this.select_fund.splice(foundIndex, 1);
                this.RemoveFundListTest(val)
                this.selectCount -= 1;
            }
            console.log(this.selectCount)
            if (this.selectCount === this.typeFundList.length) {
                this.checkBoxSelectall[0]['isChecked'] = true;
            } else {
                this.checkBoxSelectall[0]['isChecked'] = false;
            }
        }
        const selecthol = document.getElementById(elemholder) as HTMLInputElement | null;
        const selectfund = document.getElementById(elemfund) as HTMLInputElement | null;
        const butt = document.getElementById(but) as HTMLInputElement | null;
        const Year101 = document.getElementById('selectDateYearRPT101') as HTMLInputElement | null;

        if (this.selectCount === 0) {
            selecthol.disabled = true;
            selectfund.disabled = true;
            butt.disabled = true;
            Year101.disabled = true;
        } else if (this.selectCount > 0) {
            selecthol.disabled = false;
            selectfund.disabled = false;
            butt.disabled = false;
            Year101.disabled = false;
        }
        if (this.selectCount > this.typeFundList.length) {
            this.selectCount = this.typeFundList.length;
        }
    }


    AddFundListTest(val, elemholder, elemfund, but) {
        const fundLength = this.fundList.length
        let myArry = [];
        if (val === 'SSFX') {
            for (let l = 0; l < fundLength; l++) {
                const mySSFX = this.fundList[l]['FundCode'];
                myArry = mySSFX.split('-');
                if (myArry[myArry.length - 1] === val) {
                    this.fundList[l]['FundTypeGroup'] = 'SSFX'
                    this.fundListfilter.push(this.fundList[l]);
                }
            }
        }
        else {
            for (let l = 0; l < fundLength; l++) {
                const mySSFX = this.fundList[l]['FundCode'];
                myArry = mySSFX.split('-');
                if (this.fundList[l]['FundTypeGroup'] === val && myArry[myArry.length - 1] !== 'SSFX') {
                    this.fundListfilter.push(this.fundList[l]);
                }
            }
        }
        this.fundListfilter = this.fundListfilter.sort((a, b) => (a.FundCode > b.FundCode) ? 1 : -1);
        const selecthol = document.getElementById(elemholder) as HTMLInputElement | null;
        const selectfund = document.getElementById(elemfund) as HTMLInputElement | null;
        const butt = document.getElementById(but) as HTMLInputElement | null;
        const Year101 = document.getElementById('selectDateYearRPT101') as HTMLInputElement | null;
        selecthol.disabled = false;
        selectfund.disabled = false;
        butt.disabled = false;
        Year101.disabled = false;
    }

    RemoveFundListTest(val) {
        let fundListTransferlenght = this.fundListfilter.length
        for (let l = 0; l < fundListTransferlenght; l++) {
            if (this.fundListfilter[l]['FundTypeGroup'] === val) {
                this.fundListfilter.splice(l, 1);
                fundListTransferlenght = this.fundListfilter.length;
                l = l - 1;
            }
        }
    }

    // ===================================================clearAndRemoveFunction==========================================================//

    clearRPT101() {
        const selecthol101 = document.getElementById('selectHolderNoRPT101') as HTMLInputElement | null;
        const selectfund101 = document.getElementById('selectfundListRPT101') as HTMLInputElement | null;
        const butt101 = document.getElementById('but101') as HTMLInputElement | null;
        const holderno101 = document.getElementById('selectHolderNoRPT101') as HTMLInputElement | null;
        const Year101 = document.getElementById('selectDateYearRPT101') as HTMLInputElement | null;
        holderno101.value = 'HolderNoAll';
        selecthol101.disabled = true;
        selectfund101.disabled = true;
        butt101.disabled = true;
        Year101.disabled = true;
        Year101.value = this.year101[0];
    }

    clearRPT102() {
        const holderno102 = document.getElementById('selectHolderNoRPT102') as HTMLInputElement | null;
        const selecthol102 = document.getElementById('selectHolderNoRPT102') as HTMLInputElement | null;
        const selectfund102 = document.getElementById('selectfundListRPT102') as HTMLInputElement | null;
        const butt102 = document.getElementById('but102') as HTMLInputElement | null;
        holderno102.value = 'HolderNoAll';
        selecthol102.disabled = true;
        selectfund102.disabled = true;
        butt102.disabled = true;
    }

    clearRPT103() {
        const selecthol103 = document.getElementById('selectHolderNoRPT103') as HTMLInputElement | null;
        const selectfund103 = document.getElementById('selectfundListRPT103') as HTMLInputElement | null;
        const butt103 = document.getElementById('butTransfer') as HTMLInputElement | null;
        const holderno103 = document.getElementById('selectHolderNoRPT103') as HTMLInputElement | null;
        selecthol103.disabled = true;
        selectfund103.disabled = true;
        butt103.disabled = true;
        holderno103.value = 'HolderNoAll';
    }

    clearRPT106() {
        const holderno106 = document.getElementById('selectHolderNoRPT106') as HTMLInputElement | null;
        const fundlist106 = document.getElementById('selectfundListRPT106') as HTMLInputElement | null;
        fundlist106.value = 'fundListAll';
        holderno106.value = 'HolderNoAll';
    }

    clearRPT107() {
        const mouth107 = document.getElementById('selectMonth') as HTMLInputElement | null;
        const holderno107 = document.getElementById('selectHolderNo') as HTMLInputElement | null;
        holderno107.value = 'HolderAll';
        mouth107.value = this.monthListTH[0];
    }

    openTaxConsent() {
        if (this.isVerifyPIDNo == false) {
            $('#warningModalForClientReport').modal('show');
        }
        else {
            this.router.navigate(['/tax-consent']);
        }
    }
    userAgree() {
        $('#warningModalForClientReport').modal('hide');
    }

    checkClient_passport() {
        $('#warningModalForClientReport').modal('show');
        this.router.navigate(['/client-report/', 'ED']);
    }

    openAssetProfile() {
        this.router.navigate(['/asset-profile']);
    }
}
interface ConsentViewModel {
    Id: string;
    TransactionType: string;
}

interface MyObj {
    TemplateCode: string;
    HolderNo: string;
    Date: string;
}
